import { API } from 'aws-amplify';

export const create = async company => API.put('einkaufskreis', '/companies', { body: company });

export const read = async () => API.get('einkaufskreis', '/companies', {});

export const update = async company => API.post('einkaufskreis', '/companies', { body: company });

export const del = async company => API.del('einkaufskreis', `/companies/object/${company.id}`, {});
